//Created by wangshuyi on 07/03/2018.

'use strict';
const defaultParam = {
  ajaxFlag: true,
  server: '/system/dict/options/{code}',
  Vue: null,
};

class Dict {
  constructor(param) {
    this.opts = Object.assign({}, defaultParam, param);
    this.dictCache = {};
    this.dictLoading = {};
  }

  addDict(code, data) {
    this.dictCache[code] = data;
    return this;
  }

  getDict(code, params) {
    return new Promise((resolve, reject) => {
      let data = this.dictCache[code];

      if (data) {
        resolve(data);
      } else if (this.opts.ajaxFlag) {
        this.loadDict(code,params).then(options => {
          resolve(options);
        }).catch(e => {
          resolve([]);
        });
      } else {
        resolve(null);
      }
    });
  }

  loadDict(code,params) {
    const $vue = this.opts.Vue;
    return new Promise((resolve, reject) => {
      if (!this.dictCache[code] && this.dictLoading[code]) {
        let getDictFormLoading = setInterval(() => {
          if (this.dictCache[code]) {
            resolve(this.dictCache[code]);
            clearInterval(getDictFormLoading);
          }
        }, 200);
      } else {
        this.dictLoading[code] = true;
        const data = [$vue.$dotNetUtil.commonQueryJson('GM_SYS_DIC', {DIC_TYPE: code, IS_VISIBLE: 1})];
        $vue.$h5Api({
          type: '1001',
          data,
        }).then(({ data, message }) => {
          const dataList = data.DATA_LIST;
          if (dataList.length > 0) {
            let options = dataList.map(d => ({ text: d['DIC_NAME'],text_ENG: d['DIC_NAME_ENG'],text_RUS: d['DIC_NAME_RUS'], code: d[params.valueField || 'DIC_CODE'] + '', id: d['DIC_ID'] }));
            this.dictCache[code] = options;

            resolve(options);
          } else {
            reject(message);
          }
        }).catch(err => {
          reject(err.message);
        });
      }
    });
  }

  getDictText(code, option, params) {
    return this.getDict(code,params).then(options => {
      let text = option;
      options.forEach(o => {
        if (o.code == option) {
          text = o[params['labelField'] || 'text'];
        }
      });
      return text;
    }).catch(e => {
      console.error(e);
      return option;
    });
  }
}

let dict = new Dict();

let $dict = function (code, option, params = {}) {
  dict.opts.Vue = this;
  if (option || option === 0) {
    return dict.getDictText(code, option, params);
  } else {
    return dict.getDict(code, params);
  }
};
$dict.addDict = function (name, data) {
  dict.addDict(name, data);
};
export default $dict;
